import React, { FC, useState } from 'react';

import cx from 'classnames';
import { format, isValid, isDate, addYears } from 'date-fns';
import OutsideClickHandler from 'react-outside-click-handler';

import datePickerStyles from 'components/Pages/Admin/Itinerary/Details/shared/DatePickerButton/index.module.css';
import { DatePicker } from 'components/shared/DatePicker';
import DefaultInput from 'components/shared/FormAdapters/FormDefault/Input';

import s from './index.module.css';
import { IDateInputProps } from './types';
import { formatDatePickerValue } from './utils';

const DateInput: FC<IDateInputProps> = (props) => {
  const { onChange, value, highlighted, dateFormat, defaultMonth, ...rest } = props;
  const [pickerValue, setDateValue] = useState<Date>(value);
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const highlightedValue = highlighted && isDate(new Date(highlighted)) ? new Date(highlighted) : undefined;
  const parsedDefaultMonth = defaultMonth && isDate(new Date(defaultMonth)) ? new Date(defaultMonth) : undefined;

  const datepickerWrapperClasses = cx(
    datePickerStyles.popupContainer,
    s.datepickerWrapper,
    showPicker && s.datepickerWrapperActive,
  );

  const getDateFormat = (d: number | Date) => format(d, 'MM/dd/yyyy');

  const handleInputChange = ({ target }: any) => {
    const val = new Date(target.value);
    if (isValid(val)) {
      const enteredValueFormat = getDateFormat(val);

      onChange(enteredValueFormat);
      setDateValue(val);
    }
  };

  const handlePickerChange = (enteredValue?: Date) => {
    if (!enteredValue) return;

    if (isValid(enteredValue)) {
      const enteredValueFormat = getDateFormat(enteredValue);

      onChange(enteredValueFormat);
      setDateValue(enteredValue);
      setShowPicker(false);
    }
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setShowPicker(false)}>
      <div className={s.container}>
        <DefaultInput
          {...rest}
          onChange={handleInputChange}
          typeofmask="date"
          // @ts-ignore
          value={formatDatePickerValue(value, dateFormat)}
          onFocus={() => setShowPicker(true)}
          autocomplete="off"
        />

        <div className={datepickerWrapperClasses}>
          <DatePicker
            mode="single"
            onSelect={handlePickerChange}
            selected={pickerValue}
            endMonth={addYears(new Date(), 10)}
            defaultMonth={parsedDefaultMonth}
            modifiers={{ highlighted: highlightedValue }}
            modifiersClassNames={{ highlighted: s.highlightedDates }}
          />
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default DateInput;
